import { Button, FormLoader } from '@teamfabric/copilot-ui';
import { useState } from 'react';
import { useFormik } from 'formik';
import { makePost } from 'utils/httpWrapper';
import {
  StyledContainer,
  ActionsContainer,
  StyledEditorWrapper,
  StyledCardCustom,
} from 'components/IntegrationsDashboard/Visual_transformation/VisualTransformation.styles';
import ReactJson from 'react-json-view';
import { check, valueCopy } from 'components/IntegrationsDashboard/Visual_transformation/utils';
import { BASE_ERROR_CONSTANT, URL_DEBUGGING_VALIDATE } from 'utils/constants';

type Response = {
  data: object;
  status: number;
};

const VisualTransformation = ({ data }) => {
  const { endpoints, endpointIndex } = data;
  const [loading, setLoading] = useState(false);
  const [dataForAcc, setDataForAcc] = useState({});
  const [initialValues] = useState({
    variableValue: '0',
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    onSubmit: async function handleSubmit() {
      setLoading(true);
      const body = endpoints[endpointIndex];
      try {
        const url = URL_DEBUGGING_VALIDATE;
        const resp = (await makePost({ url, body })) as Response;
        console.log(resp);
        if (resp?.data && resp?.status === 200) {
          setDataForAcc(resp?.data);
        } else {
          setDataForAcc([BASE_ERROR_CONSTANT]);
        }
      } catch (err) {
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <StyledContainer data-testid="visual-transformation-container">
      <ActionsContainer>
        <Button
          disabled={formik.values.variableValue ? false : true}
          type="submit"
          form="schemaDetailsForm"
          onClick={formik.handleSubmit}
          size="small"
          text="Run"
          data-testid="visual-transformation-run-button"
        />
      </ActionsContainer>
      <StyledEditorWrapper>
        {loading ? <FormLoader theme="dark" rowCount={5} /> : null}
        {!loading && (
          <StyledCardCustom>
            <ReactJson
              src={dataForAcc}
              name={'http_data'}
              theme={'monokai'}
              iconStyle={'square'}
              enableClipboard={copy => {
                check(copy);
              }}
              onSelect={select => {
                valueCopy(select?.value);
              }}
            />
          </StyledCardCustom>
        )}
      </StyledEditorWrapper>
    </StyledContainer>
  );
};

export default VisualTransformation;
